"use client";
import dynamic from "next/dynamic";
import Findacourseskeleton from "@packages/shared-components/skeleton/findacourseskeleton";
import { useEffect, useState } from "react";
import { graphQlFetchFunction } from "@packages/lib/server-actions/server-action";
import { FIND_A_COURSE } from "@packages/lib/graphQL/find-a-course";

const Findacoursecomponents = dynamic(
  () =>
    import("@packages/shared-components/course-details/findacourse/findacoursecomponents"),
  {
    loading: () => <Findacourseskeleton />,
  }
);

export default function FindacourseWrapper({ h1value, subheading, commonGAAttrs}: any) {
  const clearing = process.env.NEXT_PUBLIC_CLEARING_FLAG === "ON";
  const [contentsData, setContents] = useState<any>(null);
  const [isContentReady, setIsContentReady] = useState(false);

  useEffect(() => {
    const fetchgraphqlData = async () => {
      const contents = await graphQlFetchFunction(FIND_A_COURSE(clearing));
      setContents(contents);
      setIsContentReady(true);
    };
    fetchgraphqlData();
  }, []);
  console.log(FIND_A_COURSE(clearing));
  return (
    <>
      {isContentReady && contentsData && (
        <Findacoursecomponents
          h1value={h1value}
          subheading={subheading}
          clearing={clearing}
          contents={contentsData}
          commonGAAttrs = {commonGAAttrs}
        />
      )}
    </>
  );
}
